// import anime from "animejs";
// import scrollMonitor from "scrollmonitor";
import Isotope from "isotope-layout";

export default class SP_Serframleidsla {
    constructor() {
        $ = jQuery;

        var iso = new Isotope(".ob-iso-grid", {
            // options
            itemSelector: ".ob-grid-item",
            layoutMode: "fitRows",
            percentPosition: true,
            fitRows: {
                gutter: ".ob-gutter-sizer",
            },
        });
        
        setTimeout(() => {
            iso.layout();
        }, 300 );
    }
}
